/* eslint-disable react/prop-types */
/** @jsxImportSource @emotion/react */

import { SortAscending, SortDescending } from '@nike/nike-design-system-icons';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { useDispatch, useSelector } from 'react-redux';
import { nike } from '@nike/nike-design-tokens';
import { useDispatchWithProgress } from '../hooks/useDispatchWithProgress';

import { SortDirectionEnum } from './invitations/SortDirectionEnum';
import { TranslatedCopy } from '../intl/TranslatedCopy';
import { invitationsActions } from './invitations/actions';
import { invitationsSelectors } from './invitations/reducer';
import { usersActions } from './users/actions';
import { usersSelectors } from './users/reducer';

const UsersInvitationsSortButtons = () => {
  const dispatch = useDispatch();
  const searchUsers = useDispatchWithProgress(usersActions.searchSortUsers);

  const invitationsActiveReview = useSelector(invitationsSelectors.activeReview);
  const usersActiveReview = useSelector(usersSelectors.activeReview);
  const selectedAccountNumber = useSelector(state => state.user.get('userAccount')?.number);
  const sortEntries = useSelector(
    invitationsActiveReview ? invitationsSelectors.sortEntries : usersSelectors.sortEntries
  );
  const usersSearch = useSelector(usersSelectors.search);
  const sortPayload = useSelector(invitationsActiveReview ? invitationsSelectors.sort : usersSelectors.sort);

  const sortFields = {
    lastName: 'name',
    email: 'email',
    role: 'role',
    active: 'status',
    isLockedOnAccount: 'status'
  };

  return sortEntries.map(([field, direction]) => (
    <div
      css={{
        alignItems: 'center',
        display: 'flex',
        width: '175.51px' // button width + icon left margin + icon width + right padding
      }}
      key={field}
    >
      <ButtonStyled
        appearance='text'
        css={{
          display: 'inline-block',
          paddingTop: '6px',
          paddingBottom: '6px',
          paddingLeft: '16px',
          width: '129.51px', // Account Status text width + left padding
          '&:hover': {
            color: nike.podiumCdsColorGrey500
          }
        }}
        name={field}
        onClick={event => {
          if (!direction) {
            sortPayload[event.target.name] = SortDirectionEnum.Asc;
          }

          if (direction === SortDirectionEnum.Asc) {
            sortPayload[event.target.name] = SortDirectionEnum.Desc;
          }

          if (direction === SortDirectionEnum.Desc) {
            sortPayload[event.target.name] = null;
          }

          if (invitationsActiveReview) {
            dispatch({
              type: invitationsActions.sortInvitations.name,
              payload: sortPayload
            });
          } else {
            dispatch({ type: usersActions.resetUsers.name });
            searchUsers({
              search: usersSearch,
              accountNumber: selectedAccountNumber,
              sort: sortPayload,
              activeOnAccount: usersActiveReview
            });
          }
        }}
        type='button'
      >
        <TranslatedCopy id={`userManagement.search.${sortFields[field]}.title`} />
      </ButtonStyled>
      <SortAscending
        css={{
          display: direction === SortDirectionEnum.Asc ? 'inline-block' : 'none',
          marginLeft: '6px',
          marginBottom: '2px' // account for font height
        }}
      />
      <SortDescending
        css={{
          display: direction === SortDirectionEnum.Desc ? 'inline-block' : 'none',
          marginLeft: '6px',
          marginBottom: '2px'
        }}
      />
    </div>
  ));
};

export default UsersInvitationsSortButtons;
